import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllTokens(_obj, params) {
    const res = await axios.get('api/integrations/tokens/', { params });
    return res.data;
  },
  async createToken(_obj, data) {
    return axios.post('api/integrations/tokens/', data);
  },
  async revokeToken(_obj, id) {
    return axios.post(`api/integrations/tokens/${id}/revoke/`);
  },
  async getAllSyncLogs(_obj, params) {
    const res = await axios.get('api/integrations/sync-logs/', { params });
    return res.data;
  },
  async getSyncLog(_obj, id) {
    return axios.get(`api/integrations/sync-logs/${id}/`);
  },
};

export const integration = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
